import { gql } from 'apollo-boost'

const SCRAPING_SESSIONS = gql`
  query scrapingSessions(
    $filters: ScrapingSessionFiltersInput!
    $page: Int
    $pageSize: Int
  ) {
    scrapingSessions(filters: $filters, page: $page, pageSize: $pageSize) {
      scrapingSessions {
        id
        status
        scrapingType
        scrapingSettings
        startedAt
        completedAt
        createdBy {
          id
          name
        }
        tagGroups {
          id
          name
          alias
          tags {
            id
            name
            type
          }
        }
        scrapingTestCaseResultCount
        scrapingTestCaseCount
      }
      total
    }
  }
`

export default SCRAPING_SESSIONS
